import { hasAttendanceApproverId } from "./attendanceDailyLogsUtils";

/** Company / super admin — matches other attendance modules. */
export const isAttendanceCompanyAdminRole = (rid) => rid === 1 || rid === 2;

/**
 * Approver queue (correction requests inbox) — roles 1–3.
 * @param {number|null|undefined} rid
 */
export const canSeeAttendanceCorrectionQueue = (rid) => rid === 1 || rid === 2 || rid === 3;

/**
 * Submitted-requests page: visible for manager & employees always; for admins only if they have an approver id.
 * @param {number|null|undefined} rid
 */
export const showAttendanceSubmittedRequestsPage = (rid) => {
  if (isAttendanceCompanyAdminRole(rid)) return hasAttendanceApproverId();
  return true;
};
